import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleMinus, faCirclePlus } from '@fortawesome/pro-light-svg-icons';
import clsx from 'clsx';
import styles from './CounterField.module.scss';

export interface CounterFieldProps {
    value?: number;
    minLimit?: number;
    maxLimit?: number;
    readOnly?: boolean;
    disabled?: boolean;
    className?: string;
    hasBorder?: boolean;
    onChange: (value: number) => void;
}

export const CounterField: React.FC<CounterFieldProps> = ({ readOnly = false, ...props }) => {
    const changeHandler = (action: 'increment' | 'decrement') => {
        if (props.value === undefined) {
            return;
        }

        if (action === 'increment') {
            incrementHandler(props.value);
        } else {
            decrementHandler(props.value);
        }
    };

    const incrementHandler = (value: number) => {
        if (props.maxLimit !== undefined && value >= props.maxLimit) {
            return;
        }

        props.onChange(value + 1);
    };

    const decrementHandler = (value: number) => {
        if (props.minLimit !== undefined && value <= props.minLimit) {
            return;
        }

        props.onChange(value - 1);
    };

    React.useEffect(() => {
        if (props.value === undefined) {
            props.onChange(props.minLimit || 1);
        }
    }, []);

    return (
        <div
            className={clsx(styles.container, props.className, props.hasBorder && styles.border, {
                [styles.disabled]: props.disabled
            })}
        >
            <button
                type="button"
                id="counter-field-decrement-button"
                className={clsx(styles.button, readOnly && styles.hidden)}
                onClick={() => changeHandler('decrement')}
            >
                <FontAwesomeIcon icon={faCircleMinus} />
            </button>
            <label className={styles.label}>{props.value}</label>
            <button
                type="button"
                id="counter-field-increment-button"
                className={clsx(styles.button, readOnly && styles.hidden)}
                onClick={() => changeHandler('increment')}
            >
                <FontAwesomeIcon icon={faCirclePlus} />
            </button>
        </div>
    );
};

export default CounterField;
